<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="库存管理" name="first">
                <auxiliary-invent ref="Invent"></auxiliary-invent> 
            </el-tab-pane>
            <el-tab-pane label="入库记录" name="second">
                <auxiliary-income ref="Income"></auxiliary-income>
            </el-tab-pane>
            <el-tab-pane label="出库记录" name="third">
                <auxiliary-cost ref="Costs"></auxiliary-cost>
            </el-tab-pane>
            <el-tab-pane label="校正记录" name="fourth">
                <auxiliary-check ref="checks"></auxiliary-check>
            </el-tab-pane>
            <el-tab-pane label="辅材种类" name="five">
                <auxiliary-type ref="Auxiliary"></auxiliary-type>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>
<script>
import AuxiliaryInvent from './components/AuxiliaryInvent.vue'//库存管理
import AuxiliaryIncome from './components/AuxiliaryIncome.vue'//入库记录
import AuxiliaryCost from './components/AuxiliaryCost.vue'//出库记录
import AuxiliaryCheck from './components/AuxiliaryCheck.vue'//校正记录
import AuxiliaryType from './components/AuxiliaryType.vue'//辅材种类
export default {
    components:{
        AuxiliaryInvent,
        AuxiliaryIncome,
        AuxiliaryCost,
        AuxiliaryCheck,
        AuxiliaryType
    },
    data(){
        return{
            activeName:'first'
        }
    },
    mounted(){
        this.$refs.Invent.searchButtonInfo(true);
    },
    methods:{
        //切换界面
        handleClick(tab){
            switch(tab.name){
                case 'second':
                    this.$refs.Income.searchButtonInfo(true);
                    this.$refs.Income.getNameList()
                    break;
                case 'third':
                    this.$refs.Costs.searchButtonInfo(true);
                    this.$refs.Costs.getNameList()
                    break;
                case 'fourth':
                    this.$refs.checks.searchButtonInfo(true);
                    break;
                case 'five':
                    this.$refs.Auxiliary.searchButtonInfo(true);
                    this.$refs.Auxiliary.getAllTypes();
                    break;
                default:
                    this.$refs.Invent.searchButtonInfo(true);
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import'@/style/layout-main.scss';
/deep/ .el-tabs__content{
    position: static;
}

/deep/.main {
  background: none;
}
</style>